import type { FaireProductEntity } from "../../entity_types/product";

export const p_mbdr9jvzt3: FaireProductEntity = {
  token: "p_mbdr9jvzt3",
  type: "product",
  name: "Allergic To Bullshit Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/d970c631a399011798a93a3452220bb5320f8aaa4a5f577e9e62c089e4d499d5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/907780638969619eaebaf1da136ad524974931a6dde32b245c797e750391750c.jpeg",
    "https://cdn.faire.com/fastly/a985c5058760465f14788c9804a8864b6e6b43a90d451f307a8f7bfcc62db537.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/5837638e8d149410d276e6e2e60231cb62a6d246b0db60c4656325b3883a8aa4.jpeg",
    "https://cdn.faire.com/fastly/8f0c5f678d6456cd7bb0f4e4c95b768fe40337713071d692d50c1bc82ce84d0e.jpeg"
  ],
  priceDollars: 6.75,
  description: "Do you tend to break out in honesty every time someone starts talking nonsense? Try these socks out. 😏\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:23.726Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
